module.exports = __webpack_public_path__ + "img/video-slide-3.a715582e.jpg";